import { useNavigate } from "react-router-dom";
import {
  Button,
  ButtonVariant,
  Typography,
  TypographyVariant,
} from "../../../components/ui-kit";
import { ContentCard } from "../components/ContentCard";
import { LoadingBlock } from "../../../components/loading-block/LoadingBlock";
import { Wrapper } from "../styles";
import { AppRoutes } from "../../../constants/routes";

/**
 * Legacy route: administrators are created with a password in the admin portal.
 * Old invitation links may still land here.
 */
const AcceptInvite = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <LoadingBlock>
        <ContentCard title="Administrator access">
          <Typography
            variant={TypographyVariant.BODY2}
            style={{ marginBottom: 16 }}
          >
            New administrators receive their credentials from an existing
            administrator. If you need access, ask your organisation to create
            your account in the admin portal.
          </Typography>
          <Button
            variant={ButtonVariant.CONTAINED}
            fullWidth
            onClick={() => navigate(AppRoutes.Open.Auth.SIGN_IN_START)}
          >
            Go to sign in
          </Button>
        </ContentCard>
      </LoadingBlock>
    </Wrapper>
  );
};

export default AcceptInvite;
